//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Modulos from '@/api/promotores/usuarios/modulos.api'
export default {
  data() {
    return {
      modulos: [],
      loading: false,
    }
  },

  mounted() {
    this.loadModulos()
  },

  methods: {
    async loadModulos() {
      try {
        this.loading = true
        this.modulos = await Modulos.all(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },

    getIcon(modulo) {
      return {
        completo: 'check_circle',
        pendiente: 'watch_later',
        manual: 'warning'
      }[ modulo.estatus ] || 'remove'
    },
  }
}
